module.exports = infra.vueExports;